import moment from "moment";

const MONTHS_AGO_STR = (n) =>
  moment.utc().startOf("month").subtract(n, "months").format("YYYY/MM/DD");
const DAY_OF_MONTH = (d) => moment.utc().startOf("day").date(d);

const aviationMonthyValues = {
  [MONTHS_AGO_STR(0)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
          {
            templateName: "NEWUSER",
            countSent: 2,
          },
          {
            templateName: "NEWUSER_MANAGER",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(1),
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF",
            countSent: 2,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(2),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: DAY_OF_MONTH(5),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(6),
      },
      {
        notifications: [
          {
            templateName: "REPORT_END_PERIOD",
            countSent: 38,
          },
        ],
        day: DAY_OF_MONTH(8),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
          {
            templateName: "NEWUSER",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(12),
      },
      {
        notifications: [
          {
            templateName: "REPORT_END_PERIOD",
            countSent: 44,
          },
          {
            templateName: "REPORT_KICKOFF",
            countSent: 1,
          },
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(13),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(15),
      },
    ],
  },
  [MONTHS_AGO_STR(1)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(3),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 72,
          },
        ],
        day: DAY_OF_MONTH(4),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: DAY_OF_MONTH(6),
      },
      {
        notifications: [
          {
            templateName: "NEWUSER",
            countSent: 1,
          },
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(8),
      },
      {
        notifications: [
          {
            templateName: "REPORT_END_PERIOD",
            countSent: 38,
          },
          {
            templateName: "REPORT_KICKOFF",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(9),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: DAY_OF_MONTH(10),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 6,
          },
        ],
        day: DAY_OF_MONTH(12),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(14),
      },
      {
        notifications: [
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 5,
          },
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 16,
          },
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(16),
      },
      {
        notifications: [
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 15,
          },
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(17),
      },
      {
        notifications: [
          {
            templateName: "NEWUSER_MANAGER",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(18),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(22),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: DAY_OF_MONTH(23),
      },
      {
        notifications: [
          {
            templateName: "REPORT_MIDMONTHLY",
            countSent: 38,
          },
        ],
        day: DAY_OF_MONTH(24),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(26),
      },
      {
        notifications: [
          {
            templateName: "SUPPORT",
            countSent: 1,
          },
          {
            templateName: "NEWUSER_MANAGER",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(29),
      },
    ],
  },
  [MONTHS_AGO_STR(2)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(1),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(2),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: DAY_OF_MONTH(11),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(13),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
          {
            templateName: "NEWUSER",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(15),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 10,
          },
          {
            templateName: "REPORT_KICKOFF",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(16),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 3,
          },
        ],
        day: DAY_OF_MONTH(17),
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(18),
      },
      {
        notifications: [
          {
            templateName: "REPORT_MIDMONTHLY",
            countSent: 38,
          },
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: DAY_OF_MONTH(19),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
          {
            templateName: "NEWUSER",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(26),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 9,
          },
          {
            templateName: "REPORT_KICKOFF",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(27),
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_FORCED",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(29),
      },
    ],
  },
  [MONTHS_AGO_STR(3)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "SUPPORT",
            countSent: 1,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
        ],
        day: 1691020800000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
        ],
        day: 1691625600000,
      },
      {
        notifications: [
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 1,
          },
        ],
        day: 1691971200000,
      },
      {
        notifications: [
          {
            templateName: "SUPPORT",
            countSent: 1,
          },
        ],
        day: 1692144000000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 4,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
        ],
        day: 1692230400000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 3,
          },
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 5,
          },
        ],
        day: 1692316800000,
      },
      {
        notifications: [
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 6,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
        ],
        day: 1692576000000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_FORCED",
            countSent: 1,
          },
          {
            templateName: "ACCOUNTLOCKED",
            countSent: 1,
          },
          {
            templateName: "SUPPORT",
            countSent: 1,
          },
        ],
        day: 1692662400000,
      },
      {
        notifications: [
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
        ],
        day: 1692748800000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 28,
          },
        ],
        day: 1693440000000,
      },
    ],
  },
  [MONTHS_AGO_STR(4)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 1,
          },
        ],
        day: 1688169600000,
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF",
            countSent: 2,
          },
          {
            templateName: "REPORT_END_PERIOD",
            countSent: 31,
          },
        ],
        day: 1688428800000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_FORCED",
            countSent: 1,
          },
        ],
        day: 1689120000000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
        ],
        day: 1689206400000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_FORCED",
            countSent: 1,
          },
        ],
        day: 1689292800000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: 1689724800000,
      },
    ],
  },
  [MONTHS_AGO_STR(5)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 3,
          },
        ],
        day: 1685577600000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 3,
          },
          {
            templateName: "REPORT_END_PERIOD",
            countSent: 32,
          },
        ],
        day: 1685836800000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: 1686096000000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: 1686268800000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 4,
          },
        ],
        day: 1686355200000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: 1686441600000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: 1686614400000,
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 2,
          },
          {
            templateName: "MILESTONES",
            countSent: 5,
          },
          {
            templateName: "REPORT_KICKOFF",
            countSent: 1,
          },
        ],
        day: 1686700800000,
      },
      {
        notifications: [
          {
            templateName: "MILESTONES",
            countSent: 2,
          },
        ],
        day: 1686787200000,
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 2,
          },
        ],
        day: 1686873600000,
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 1,
          },
          {
            templateName: "REPORT_KICKOFF",
            countSent: 6,
          },
          {
            templateName: "REPORT_MIDMONTHLY",
            countSent: 31,
          },
          {
            templateName: "PASSWORD_CHANGED",
            countSent: 1,
          },
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 2,
          },
        ],
        day: 1687132800000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
        ],
        day: 1687392000000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
        ],
        day: 1687478400000,
      },
      {
        notifications: [
          {
            templateName: "RESETPASSWORD_REQUESTED",
            countSent: 1,
          },
        ],
        day: 1687824000000,
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 5,
          },
        ],
        day: 1687910400000,
      },
    ],
  },
};

export const getCalendarNotificationsPerTemplatePerDayAviation = (
  teamId,
  startDate,
) => {
  //dates older than 5 months ago get '5 months ago'
  const keyDate = moment.max(
    moment.utc(startDate).startOf("month"),
    moment.utc().startOf("month").subtract(5, "months"),
  );
  const key = moment.utc(keyDate).format("YYYY/MM/DD");

  const data = aviationMonthyValues[key];
  return data;
};
